module.exports = __webpack_public_path__ + "static/Galeb_Duhr-9c52f30063acf19fb1a867598cd42c50.jpg";